import i18n from '@/config/i18n'
import Vue from 'vue'
import {SnotifyPosition} from 'vue-snotify'

export default {
    data() {
        return {
        }
    },
    mounted() {
        $('[data-popup=tooltip-custom]').tooltip({
            template: '<div class="tooltip"><div class="bg-teal"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div></div>'
        });
    },
    computed: {
        currentRoute: function() {
            return this.$route
        },
        currentLocale: function() {
            return i18n.locale
        },
    },
    methods: {
        resObj(res,pageable) {

            let pageInfo = {
                page:1,
                pages:[1]
            }
            let response = {
                content:pageable?[]:{},
                pageInfo: pageInfo
            }

            if(!res) return response
            let result = res.data.content
            if (res && res.data.code === 1000) {
                response.content = result.content
                if(pageable) {
                    pageInfo.page = result.pageable.pageNumber
                    pageInfo.size = result.pageable.pageSize
                    pageInfo.totalPages = result.totalPages
                    pageInfo.pages = []
                    for(let i=0; i < result.totalPages; i++) {
                        pageInfo.pages.push(i+1)
                    }
                } else {
                    this.$notify.success(res.data.message)
                }
            } else {
                this.$notify.error(res.data.code, res.data.message)
            }

            return response
        },
        changeLocale(locale) {
            i18n.locale = locale
        },
        refresh() {
            location.reload()
        },
        callModal(data) {
            this.$refs.modal.modalShow(data)
        },
        moveTo(path,query) {
            if(query) {
                this.$router.push({path: path, query: query})
            } else {
                this.$router.push({path: path})
            }
        },
        historyBack() {
            this.$router.go(-1)
        },
        hasRole(role) {
            let roles = this.$store.getters[this.$const.GETTERS.GET_USER_ROLE]
            return roles.includes(role)
        },
        codemirrorRefresh: function() {
            $('.CodeMirror').each(function(i, el){
                setTimeout(function() {
                    el.CodeMirror.refresh()
                },500)
            });
        },

    }
}
